import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberForm from '../../../components/forms/MemberForm';
import { useMemberApi } from '../../../hooks/useMemberApi';
import { useNavigate } from 'react-router-dom';
import { MemberDTO } from '../../../services/apiClient';

const MemberCreate: React.FC = () => {
  const { create, isLoading } = useMemberApi();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Members', href: '/admin/members' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: MemberDTO) => {
    try {
      await create(data);
      navigate('/admin/members');
    } catch (error) {
      console.error('Error creating Member:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/members"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Manage.Members.Edit'
    >
        <MemberForm
          initialValues={{} as MemberDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/members')}
        />
    </AdminLayout>
  );
};

export default MemberCreate;